// ----------------------------------------------------------------------

const es = {
  videoLibrary: {
    noFolder: `Videos sin carpeta`,
    status: {
      ready: `Listo`,
      processing: `Procesando`,
      failed: `Falló`,
    },
    actions: {
      download: `Descargar`,
      edit: `Editar`,
      delete: `Eliminar`,
      save: `Guardar`,
      cancel: `Cancelar`,
      moreOptions: `Más opciones`,
      move: `Mover a carpeta`,
    },
    selection: {
      selectAll: `Seleccionar todos`,
      selectVideo: `Seleccionar {{title}}`,
      countInFolder: `{{selected}} de {{total}} seleccionados en esta carpeta`,
      countFiltered: `{{selected}} de {{total}} seleccionados en esta carpeta, con filtro aplicado`,
      move: `Mover a carpeta`,
      clear: `Limpiar selección`,
      footer_one: `{{count}} seleccionado`,
      footer_other: `{{count}} seleccionados`,
    },
    moveVideos: {
      title_one: `Mover {{count}} video`,
      title_other: `Mover {{count}} videos`,
      description: `Los videos salen de "{{source}}" hacia la carpeta elegida y siguen vinculados a las clases que ya los usan.`,
      destination: `Carpeta de destino`,
      choose: `Elige la carpeta`,
      noDestination: `Crea otra carpeta para tener un destino.`,
      confirm: `Mover`,
      cancel: `Cancelar`,
      close: `Cerrar`,
      moving: `Moviendo {{done}} de {{total}}…`,
      resultTitle: `{{moved}} de {{total}} videos movidos a "{{destination}}"`,
      failedTitle_one: `{{count}} video no se movió:`,
      failedTitle_other: `{{count}} videos no se movieron:`,
      failedDefaultReason: `No se pudo mover este video.`,
      reasons: {
        notFound: `Video no encontrado en tu biblioteca.`,
      },
    },
    deleteVideo: {
      title: `Estás a punto de eliminar este video permanentemente.`,
      content: `Esta acción no se puede deshacer.\nEl video se eliminará definitivamente de la plataforma.`,
      cancel: `Cancelar`,
      confirm: `Eliminar`,
      deleting: `Eliminando...`,
    },
    deleteFolder: {
      title: `Estás a punto de eliminar esta carpeta.`,
      content: `Los videos de esta carpeta se moverán a "Videos sin carpeta".\nEsta acción no se puede deshacer.`,
      cancel: `Cancelar`,
      confirm: `Eliminar`,
      deleting: `Eliminando...`,
    },
    toasts: {
      inProgress: `Carga en curso. No cierres esta pantalla.`,
      partialFailed: `Algunos videos no se pudieron enviar. Inténtalo de nuevo.`,
      failed: `La carga falló. Inténtalo de nuevo.`,
      success: `¡Cargas completadas con éxito!`,
      blockClose: `Hay cargas en curso. Espera a que finalicen antes de cerrar.`,
      folderCreated: `Carpeta creada.`,
      folderRenamed: `Carpeta renombrada.`,
      folderDeleted: `Carpeta eliminada.`,
      videoRenamed: `Video renombrado.`,
      videoDeleted: `Video eliminado.`,
      videosMoved_one: `{{count}} video movido a "{{destination}}".`,
      videosMoved_other: `{{count}} videos movidos a "{{destination}}".`,
    },
    empty: {
      noFolders: `No se encontraron carpetas`,
      noVideos: `No hay archivos en esta carpeta`,
    },
    download: {
      title: `Tu video se está descargando`,
      content: `Estamos finalizando la descarga para ti.\nNo cierres esta página hasta que termine la descarga`,
    },
    errors: {
      load: `No se pudieron cargar los videos. Inténtalo de nuevo.`,
      createFolder: `Error al crear la carpeta. Inténtalo de nuevo.`,
      renameFolder: `No se pudo renombrar la carpeta. Inténtalo de nuevo.`,
      deleteFolder: `No se pudo eliminar la carpeta. Inténtalo de nuevo.`,
      renameVideo: `No se pudo renombrar el video. Inténtalo de nuevo.`,
      deleteVideo: `No se pudo eliminar el video. Inténtalo de nuevo.`,
      moveVideos: `No se pudieron mover los videos. Inténtalo de nuevo.`,
      upload: `Error al enviar el video. Inténtalo de nuevo.`,
      duplicateFile: `Este video ya fue agregado.`,
      maxFilesExceeded_one: `Puedes subir un máximo de {{max}} videos a la vez. {{count}} video no fue agregado.`,
      maxFilesExceeded_other: `Puedes subir un máximo de {{max}} videos a la vez. {{count}} videos no fueron agregados.`,
      maxFileSizeExceeded_one: `{{count}} video supera el tamaño máximo de {{max}} y no fue agregado.`,
      maxFileSizeExceeded_other: `{{count}} videos superan el tamaño máximo de {{max}} y no fueron agregados.`,
      invalidFormat_one: `El formato del archivo {{names}} no es válido. Envía solo archivos en los formatos: MP4, MOV, AVI o MKV. Inténtalo de nuevo.`,
      invalidFormat_other: `El formato de los archivos {{names}} no es válido. Envía solo archivos en los formatos: MP4, MOV, AVI o MKV. Inténtalo de nuevo.`,
    },
  },
  productMembersArea: {
    lessonMaterials: {
      sectionTitle: `Materiales extra`,
      empty: `No hay materiales añadidos a esta clase.`,
      download: `Descargar`,
      delete: `Eliminar`,
      confirmDeleteTitle: `¿Deseas eliminar el material?`,
      confirmDeleteContent: `El material será eliminado del área de miembros.`,
      confirmDeleteAction: `Eliminar material`,
      cancel: `Cancelar`,
      deleteSuccess: `Material eliminado con éxito.`,
      retry: `Intentar de nuevo`,
      addTitle: `Añadir material`,
      titleLabel: `Título`,
      descriptionLabel: `Descripción (opcional)`,
      chooseFile: `Elegir archivo`,
      fileHelperFormats: `Formatos aceptados: {{formats}}.`,
      fileHelperMaxSize: `Tamaño máximo: {{max}} por archivo.`,
      fileTypeWarning: `Formato fuera de la lista de aceptados: {{formats}}. El envío puede ser rechazado.`,
      limitsLoading: `Cargando los límites de envío…`,
      limitsUnavailable: `No se pudieron cargar los límites de envío. El archivo se validará al enviar.`,
      capacity: `Esta clase tiene {{total}} de {{max}} materiales. Todavía hay espacio para {{remaining}}.`,
      capacityReached: `Esta clase alcanzó el límite de {{max}} materiales. Para añadir otro, elimina uno de los actuales.`,
      capacityExceeded: `Esta clase tiene {{total}} materiales, por encima del límite de {{max}}. Todos siguen disponibles para los alumnos, pero para añadir uno nuevo debes eliminar al menos {{toRemove}}.`,
      capacityQueueExceeded: `La cola supera el límite de {{max}} materiales por clase: quita {{excess}} de la cola antes de guardar.`,
      uploading: `Enviando… {{percent}}% · {{loaded}} de {{total}}`,
      cancelUpload: `Cancelar envío`,
      uploadCanceled: `Envío cancelado. No se añadió ningún material.`,
      flushCanceled: `Envío cancelado. Los materiales que no subieron siguen en la lista para que lo intentes de nuevo.`,
      addButton: `Añadir`,
      createSuccess: `Material añadido con éxito.`,
      errors: {
        load: `Error al cargar los materiales de la clase.`,
        create: `Error al añadir el material. Inténtalo de nuevo.`,
        delete: `Error al eliminar el material. Inténtalo de nuevo.`,
        download: `Error al descargar el material. Inténtalo de nuevo.`,
        popupBlocked: `El navegador bloqueó la nueva pestaña. Permite las ventanas emergentes para este sitio e inténtalo de nuevo.`,
        notFound: `Material no encontrado.`,
        lessonNotFound: `Clase no encontrada.`,
        forbidden: `No tienes permiso para esta acción.`,
        fileTooLarge: `Archivo demasiado grande. Tamaño máximo: {{max}} por archivo.`,
        invalidFileType: `Formato no aceptado. Envía un archivo en uno de estos formatos: {{formats}}.`,
        uploadTimeout: `El envío tardó más de lo permitido y se interrumpió. No se añadió ningún material. Prueba con una conexión más rápida o un archivo más pequeño.`,
        uploadNetwork: `La conexión se cortó durante el envío. No se añadió ningún material. Revisa la conexión e inténtalo de nuevo.`,
        batchOverLimit: `No se envió ningún material: la clase acepta hasta {{max}} materiales y hay espacio para {{available}} más. Quita {{excess}} de la cola y guarda de nuevo.`,
        invalidFileKey: `Clave de archivo no válida.`,
        titleRequired: `El título es obligatorio.`,
      },
    },
  },
  subscriptionsDrawer: {
    canceledBy: {
      subscriber: `Cancelada por el suscriptor`,
      producer: `Cancelada por el productor`,
      api: `Cancelada por la integración (API)`,
      system: `Cancelada por Cakto`,
    },
    cancellationReason: `Motivo: {{reason}}`,
  },
  demo: {
    title: `Español`,
    introduction: `Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor desconocido usó una galería de textos y los mezcló de tal manera que logró hacer un libro de textos especimen.`,
  },
  docs: {
    hi: `Hola`,
    description: `¿Necesitas ayuda? \n Consulta nuestra documentación.`,
    documentation: `documentación`,
  },
  languages: {
    pt: `Brasil`,
    en: `Inglés`,
    es: `Español`,
    cn: `Chino`,
  },
  pagination: {
    previousPage: `Página anterior`,
    nextPage: `Página siguiente`,
  },
  app: `aplicación`,
  user: `usuario`,
  list: `lista`,
  edit: `editar`,
  shop: `tienda`,
  blog: `blog`,
  post: `publicación`,
  mail: `correo`,
  chat: `chat`,
  cards: `tarjetas`,
  posts: `publicaciones`,
  create: `crear`,
  kanban: `kanban`,
  general: `general`,
  banking: `banca`,
  booking: `reservas`,
  profile: `perfil`,
  account: `cuenta`,
  product: `producto`,
  invoice: `factura`,
  details: `detalles`,
  checkout: `pago`,
  calendar: `calendario`,
  analytics: `analíticas`,
  ecommerce: `comercio electrónico`,
  management: `gestión`,
  menu_level: `nivel de menú`,
  menu_level_2a: `nivel de menú 2a`,
  menu_level_2b: `nivel de menú 2b`,
  menu_level_3a: `nivel de menú 3a`,
  menu_level_3b: `nivel de menú 3b`,
  menu_level_4a: `nivel de menú 4a`,
  menu_level_4b: `nivel de menú 4b`,
  item_disabled: `elemento desactivado`,
  item_label: `etiqueta del elemento`,
  item_caption: `leyenda del elemento`,
  item_external_link: `enlace externo del elemento`,
  description: `descripción`,
  other_cases: `otros casos`,
  item_by_roles: `elemento por roles`,
  only_admin_can_see_this_item: `Solo el administrador puede ver este elemento`,
  ratingSurvey: {
    logoAlt: `Logo Cakto`,
    pageTitle: `¡Queremos saber tu opinión!`,
    pageSubtitle: `Tu respuesta nos ayuda a mejorar continuamente nuestros productos.`,
    satisfactionQuestion: `¿Cuál es tu nivel de satisfacción con el producto?`,
    commentLabel: `¿Puedes contarnos el motivo de tu calificación?`,
    commentPlaceholder: `Escribe aquí tu respuesta...`,
    charCount: `{{count}}/500 caracteres`,
    submit: `Enviar comentarios`,
    submitting: `Enviando...`,
    errorGeneric: `No se pudo enviar la evaluación. Inténtalo de nuevo.`,
    cactusLabels: {
      1: { line1: `Muy`, line2: `¡Insatisfecho!` },
      2: { line1: `Insatisfecho`, line2: `` },
      3: { line1: `Neutral`, line2: `` },
      4: { line1: `¡Satisfecho!`, line2: `` },
      5: { line1: `Muy`, line2: `¡Satisfecho!` },
    },
    validation: {
      ratingRequired: `La calificación es obligatoria`,
      ratingMin: `Selecciona al menos 1 cactus`,
      ratingMax: `Máximo 5 cactus`,
      commentRequired: `El comentario es obligatorio`,
      commentMin: `Por favor, describe mejor tu experiencia (mínimo 10 caracteres)`,
    },
    errorState: {
      expired: {
        title: `Tu enlace de encuesta ha caducado`,
        messageBold: `La encuesta está disponible hasta 7 días después de tu compra.`,
        messageNormal: `Ese plazo ayuda a que el comentario refleje tu experiencia más reciente. Podrás participar de nuevo en una próxima compra si lo deseas.`,
      },
      already_used: {
        title: `Evaluación ya enviada`,
        message: `Ya enviaste tu evaluación de este producto. ¡Gracias por tu comentario!`,
      },
      error: {
        title: `Enlace no válido`,
        message: `Este enlace no es válido. Comprueba que copiaste el enlace completo del correo.`,
      },
      goToPlatform: `Ir a la plataforma`,
    },
  },
  subscriberFlow: {
    common: {
      logoAlt: `Logo de Cakto`,
      loadError: {
        title: `No pudimos cargar`,
        description: `Tuvimos un problema al buscar tu información. Esto no significa que no tengas suscripciones.`,
        retry: `Intentar de nuevo`,
      },
      backToSubscriptions: `Mis suscripciones`,
      signOut: `Salir`,
      price: `{{amount}}/{{interval}}`,
      interval: {
        monthly: `mes`,
        yearly: `año`,
        weekly: `semana`,
        everyNDays: `{{days}} días`,
      },
      paymentMethod: {
        card: `Tarjeta de crédito`,
        cardWithDigits: `Tarjeta •••• {{lastDigits}}`,
        automaticPix: `Pix Automático`,
        pix: `Pix`,
        boleto: `Boleto`,
      },
    },
    home: {
      title: `Mis suscripciones`,
      description: `Accede con el correo o el teléfono que usaste en la compra. Sin contraseña y sin nuevo registro — te enviamos un código de verificación.`,
      identifierLabel: `Correo o teléfono usado en la compra`,
      identifierPlaceholder: `Escribe tu correo o teléfono (con prefijo)`,
      sendCode: `Recibir código de acceso`,
      comingSoon: `Muy Pronto`,
      google: {
        signIn: `Entrar con Google`,
        or: `o`,
        signingIn: `Entrando con Google…`,
        notice: {
          noAccount: `No encontramos una cuenta o suscripción con el correo de Google. Indica el correo o el teléfono usado en la compra.`,
          useCode: `Para este correo, confirma con el código: escribe el correo abajo.`,
          expired: `Tu acceso con Google expiró. Inténtalo de nuevo.`,
          failed: `No fue posible entrar con Google. Inténtalo de nuevo.`,
        },
      },
      link: {
        signingIn: `Abriendo tu suscripción…`,
        notice: {
          invalid: `Este enlace de acceso venció o ya no es válido. Entra con el correo que usaste en la compra para continuar.`,
          failed: `No pudimos abrir tu suscripción desde el enlace ahora. Entra con el correo que usaste en la compra para continuar.`,
          sessionEnded: `Tu sesión desde el enlace terminó. Abre de nuevo el enlace del aviso o entra con el correo de la compra.`,
        },
      },
      validation: {
        identifierRequired: `Indica el correo o el teléfono usado en la compra`,
        identifierInvalid: `Indica un correo válido o un teléfono con prefijo`,
      },
      toast: {
        codeResent: `Código reenviado.`,
        codeResentEmail: `Código reenviado. Revisa tu correo.`,
        codeResentWhatsapp: `Código reenviado. Revisa tu WhatsApp.`,
      },
      errors: {
        sendCode: `No pudimos enviar el código. Inténtalo de nuevo en unos instantes.`,
        tooManyAttempts: `Demasiados intentos en poco tiempo. Espera un minuto e inténtalo de nuevo.`,
        phoneLoginUnavailable: `El acceso por teléfono no está disponible en este momento. Usa el correo de la compra.`,
      },
    },
    verifyCode: {
      description: `Enviamos un código de 6 dígitos a {{identifier}}.`,
      descriptionEmail: `Enviamos un código de 6 dígitos a {{identifier}} por correo.`,
      descriptionWhatsapp: `Enviamos un código de 6 dígitos a {{identifier}} por WhatsApp.`,
      codeLabel: `Código de verificación`,
      codePlaceholder: `000000`,
      submit: `Entrar`,
      changeIdentifier: `Cambiar correo/teléfono`,
      resendCode: `Reenviar código`,
      resendCodeIn: `Reenviar código en {{seconds}}s`,
      resendCodeLocked: `Reenviar código en {{minutes}} min`,
      lockOver: `La espera terminó. Pide un código nuevo para entrar.`,
      validation: {
        codeInvalid: `Escribe el código de 6 dígitos que enviamos.`,
      },
      errors: {
        confirmCode: `No pudimos confirmar el código. Inténtalo de nuevo.`,
        wrongCode: `Código inválido o vencido. Revisa el código o pide uno nuevo.`,
        locked: `Demasiados intentos con un código incorrecto. Por seguridad, espera {{minutes}} min y pide un código nuevo.`,
      },
    },
    header: {
      loggedInAs: `Sesión de`,
      linkAccess: `Acceso desde el enlace del aviso`,
      signInWithEmail: `Entrar con correo`,
    },
    subscriptionsPage: {
      title: `Mis suscripciones`,
      description: `Gestiona el pago y sigue tus suscripciones activas. Sesión de {{identifier}} — sin nuevo registro.`,
      descriptionLink: `Entraste desde el enlace del aviso y solo ves esta suscripción. Para ver las demás, entra con el correo de la compra.`,
      status: {
        active: `Activa`,
        inactive: `Inactiva`,
        paymentPending: `Pago pendiente`,
        chargeProcessing: `Procesando cobro`,
        canceled: `Cancelada`,
        expired: `Vencida`,
        paused: `Pausada`,
        trial: `En prueba`,
        late: `Atrasada`,
      },
      caption: {
        active: `{{price}} · {{method}} · próximo cobro el {{nextChargeAt}}`,
        canceled: `{{price}} · {{method}} · cancelada el {{canceledAt}} · próximos cobros interrumpidos`,
        canceledWithoutDate: `{{price}} · {{method}} · cancelada · próximos cobros interrumpidos`,
        paymentPending: `{{price}} · pago no identificado el {{failedAt}}`,
        paymentPendingWithoutDate: `{{price}} · pago no identificado`,
      },
      pendingCallout: `Tu cobro no fue aprobado. Se harán nuevos intentos automáticos — actualiza tu método de pago antes del último intento ({{lastRetryAt}}) para evitar la cancelación por impago.`,
      pendingCalloutWithoutDate: `Tu cobro no fue aprobado. Se harán nuevos intentos automáticos — actualiza tu método de pago antes del último intento para evitar la cancelación por impago.`,
      pendingCalloutWithoutRetry: `Tu cobro no fue aprobado y no habrá nuevos intentos automáticos.`,
      pendingCalloutPixRenewalExpired: `El Pix de la renovación venció y ya no se puede pagar. Elige cómo pagar para mantener tu suscripción.`,
      resolvedByAutomaticPixCallout: `Pix Automático autorizado. El nuevo cobro se está procesando — si se aprueba, el impago se resuelve y el estado vuelve a "Activa".`,
      actions: {
        resolveNow: `Resolver ahora`,
        changePaymentMethod: `Cambiar método de pago`,
        reactivate: `Suscribirme de nuevo`,
        viewHistory: `Ver historial`,
        cancelSubscription: `Cancelar suscripción`,
        cancelNeedsEmail: `Para cancelar, entra con el correo de la compra`,
      },
      empty: {
        title: `Todavía no tienes suscripciones`,
        description: `Cuando te suscribas a un producto en Cakto, aparecerá aquí — activa o cerrada — con su estado, importe y fecha del próximo cobro.`,
      },
      reactivateHint: `Esto crea una suscripción nueva, al precio y en las condiciones que la oferta tiene hoy. La suscripción anterior sigue cerrada.`,
      support: `¿Necesitas ayuda? Habla con el productor por el correo de soporte indicado en la compra.`,
      toast: {
        subscriptionCanceled: `Suscripción cancelada. Los próximos cobros se detienen ahora.`,
        cancelFailed: `No pudimos cancelar la suscripción. Inténtalo de nuevo o habla con soporte.`,
      },
    },
    cancelDialog: {
      title: `Cancelar suscripción`,
      description: `La suscripción {{productName}} se cancelará. Los próximos cobros se detienen ahora.`,
      irreversible: `Esta acción no se puede deshacer. Para volver a tener acceso después, tendrás que suscribirte de nuevo, con el precio y las condiciones vigentes.`,
      inputLabel: `Escribe {{phrase}} para confirmar`,
      inputHelper: `Confirmación obligatoria para evitar una cancelación por error.`,
      keep: `Mantener suscripción`,
      confirm: `Confirmar cancelación`,
      confirmationPhrase: `CANCELAR SUSCRIPCIÓN`,
      reasonLabel: `¿Por qué cancelas? (opcional)`,
      reasons: {
        preferNotToSay: `Prefiero no decirlo`,
        tooExpensive: `Se volvió caro`,
        notUsing: `No lo estoy usando`,
        notAsExpected: `No era lo que esperaba`,
        accessProblem: `Problema de acceso`,
        other: `Otro motivo`,
      },
      errors: {
        alreadyCanceled: `Esta suscripción ya está cancelada.`,
        notCancelable: `Esta suscripción no se puede cancelar por aquí en este momento. Habla con el productor por el correo de soporte indicado en la compra.`,
        notLinked: `No encontramos esta suscripción para cancelarla. Habla con el productor por el correo de soporte indicado en la compra.`,
        cancelDisabled: `La cancelación por el portal no está disponible en este momento. Inténtalo de nuevo más tarde.`,
        cancelLateDisabled: `Con un pago pendiente, la cancelación por aquí no está disponible en este momento. Resuelve el pago o inténtalo de nuevo más tarde.`,
        invalidReason: `No reconocimos el motivo elegido. Elige otro, o "Prefiero no decirlo", e inténtalo de nuevo.`,
        emailScopeRequired: `Para cancelar, entra con el correo usado en la compra.`,
        unavailable: `No pudimos cancelar ahora, y la suscripción no cambió. Inténtalo de nuevo en unos minutos.`,
        unconfirmed: `No pudimos confirmar la cancelación. Revisa tu lista de suscripciones antes de intentarlo de nuevo.`,
        tooManyAttempts: `Demasiados intentos de cancelación. Espera un poco e inténtalo de nuevo más tarde.`,
      },
    },
    paymentPage: {
      title: `Actualizar forma de pago`,
      contextPending: `{{productName}} · {{price}} · pago pendiente desde el {{failedAt}}`,
      contextPendingWithoutDate: `{{productName}} · {{price}} · pago pendiente`,
      contextActive: `{{productName}} · {{price}} · al día`,
      callouts: {
        recoveryEmail: `Llegaste desde el correo de recuperación — esta es la suscripción pendiente que mencionaba.`,
        renewalReminder: `Llegaste desde el recordatorio de renovación. Aquí puedes revisar el método de pago del próximo cobro y cambiarlo antes de la renovación.`,
      },
      notFound: {
        title: `Suscripción no encontrada`,
        description: `No la encontramos entre las tuyas. Si llegaste desde un correo, entra con el correo o el teléfono usado en esa compra.`,
        switchAccount: `Entrar con otro correo o teléfono`,
      },
      errors: {
        subscriptionNotLinked: `No es posible cambiar el pago de esta suscripción aquí. Habla con el productor por el correo de soporte indicado en la compra.`,
        subscriptionEnded: `Esta suscripción terminó. Para continuar, suscríbete de nuevo.`,
        pixPaymentPending: `Ya tienes un Pix generado para este cobro. Paga ese Pix o espera a que venza para usar otra forma de pago.`,
        paymentMethodNotEnabled: `Esta forma de pago no está disponible para esta suscripción. Elige otra.`,
      },
      methods: {
        creditCard: `Tarjeta de crédito`,
        automaticPix: `Pix Automático`,
        pix: `Pix`,
      },
      card: {
        holderNameLabel: `Nombre del titular`,
        holderNamePlaceholder: `Como está impreso en la tarjeta`,
        numberLabel: `Número de la tarjeta`,
        numberPlaceholder: `0000 0000 0000 0000`,
        expirationLabel: `Vencimiento`,
        expirationPlaceholder: `MM/AA`,
        cvvLabel: `CVV`,
        cvvPlaceholder: `000`,
        submitPending: `Guardar y ejecutar un nuevo cobro`,
        submitActive: `Guardar nueva tarjeta`,
        footnote: `El cobro pendiente se procesa de inmediato en la nueva tarjeta. Tu historial anterior se mantiene.`,
        retry: `Intentar de nuevo`,
        errors: {
          infrastructure: `No pudimos procesar el cobro ahora. Inténtalo de nuevo en unos minutos.`,
          cardNotProcessed: `No pudimos procesar esta tarjeta. Revisa los datos o usa otra tarjeta.`,
          issuerTimed: `El banco emisor rechazó el cobro por ahora, por ejemplo por límite o saldo insuficiente. Usa otra tarjeta o inténtalo más tarde.`,
          issuer: `El banco emisor de la tarjeta rechazó el cobro. Usa otra tarjeta.`,
          notApproved: `El cobro no fue aprobado. Usa otra tarjeta.`,
          chargeInProgress: `No pudimos guardar la tarjeta ahora. Puede que ya haya un cobro de esta suscripción en curso: revisa la suscripción antes de intentarlo de nuevo.`,
          unconfirmed: `No pudimos confirmar el cambio de tarjeta ni el cobro. Revisa la suscripción en unos minutos antes de intentarlo de nuevo.`,
          tooManyAttempts: `Hiciste demasiados intentos. Espera un poco antes de intentarlo de nuevo.`,
          emailScopeRequired: `Para cambiar la suscripción, entra con el correo usado en la compra.`,
          invalidCard: `Revisa los datos de la tarjeta.`,
          generic: `No pudimos guardar la tarjeta.`,
        },
        validation: {
          holderNameRequired: `Ingrese el nombre del titular como está en la tarjeta.`,
          numberInvalid: `Escribe los 16 dígitos de la tarjeta.`,
          expirationFormat: `Usa el formato MM/AA.`,
          expirationMonth: `Mes inválido. Usa 01 a 12.`,
          expirationExpired: `Tarjeta vencida. Usa una tarjeta con vencimiento futuro.`,
          cvvInvalid: `El CVV tiene 3 dígitos. Míralo en el reverso de la tarjeta.`,
        },
      },
      automaticPix: {
        explanation: `El Pix Automático debita el importe de la suscripción directamente de tu cuenta en cada ciclo, sin que tengas que hacer nada. Lo autorizas una sola vez en la app de tu banco.`,
        start: `Generar autorización en mi banco`,
        footnote: `Tu historial de cobros anteriores se mantiene tras la migración.`,
        waitingTitle: `Esperando la confirmación de tu banco`,
        waitingDescription: `Abre la app de tu banco, escanea el código y autoriza el Pix Automático de {{productName}} ({{price}}).`,
        waitingPolling: `Verificando cada 5 segundos…`,
        waitingBack: `Volver`,
        pollingExhausted: `No recibimos la confirmación de tu banco. Si ya lo autorizaste, espera unos minutos y recarga la página.`,
        generatingQr: `Generando código…`,
        pendingWithoutQr: `Ya hay una autorización esperando a tu banco.`,
        applyingTitle: `Aprobada por el banco, aplicando el cambio`,
        applyingDescription: `Tu banco autorizó el Pix Automático de {{productName}}. Estamos cambiando el método de pago de tu suscripción, lo que toma unos instantes.`,
        applyingExhausted: `Tu banco lo aprobó. El cambio todavía se está aplicando; vuelve en unos minutos.`,
        copyCode: `Copiar código Pix`,
        codeCopied: `Código Pix copiado.`,
        copyFailed: `No pudimos copiar el código.`,
        unavailable: {
          disabled: `El Pix Automático no está disponible en este momento. Usa la tarjeta de crédito.`,
          subscription: `El Pix Automático no está disponible para esta suscripción. Usa la tarjeta de crédito.`,
          alreadyActive: `Esta suscripción ya está en Pix Automático.`,
          notDelinquent: `El Pix Automático se autoriza junto con un cobro pendiente, y esta suscripción está al día.`,
        },
      },
      noMethods: `No es posible pagar esta suscripción por aquí. Habla con el productor por el correo de soporte indicado en la compra.`,
      pix: {
        generating: `Generando el Pix…`,
        title: `Paga con Pix`,
        description: `Abre la app de tu banco y paga {{amount}} de {{productName}} con el código QR o el código copia y pega.`,
        expiresAt: `Válido hasta {{expiresAt}}`,
        copyCode: `Copiar código Pix`,
        codeCopied: `Código Pix copiado.`,
        copyFailed: `No fue posible copiar el código.`,
        waitingPolling: `Esperando el pago. Verificando cada 5 segundos…`,
        pollingExhausted: `Todavía no recibimos la confirmación del pago.`,
        checkAgain: `Ya pagué, verificar de nuevo`,
        expired: `Este Pix venció y ya no se puede pagar. Genera uno nuevo para pagar.`,
        canceled: `Este Pix fue cancelado y ya no se puede pagar. Genera uno nuevo para pagar.`,
        generateNew: `Generar nuevo Pix`,
        retry: `Intentar de nuevo`,
        footnote: `Tu suscripción sigue en Pix: las próximas renovaciones también llegan por código QR.`,
        errors: {
          notEnabled: `El Pix no está disponible para esta suscripción. Elige otra forma de pago.`,
          notDelinquent: `No hay cobros pendientes en esta suscripción: ya está al día.`,
          chargeInProgress: `Ya hay un cobro de esta suscripción en curso. Revisa la suscripción antes de generar un Pix.`,
          unavailable: `No pudimos generar el Pix ahora. Intenta de nuevo en unos minutos.`,
          generic: `No fue posible generar el Pix.`,
        },
      },
      toast: {
        cardUpdated: `Método de pago actualizado.`,
        chargeProcessing: `El cobro en la nueva tarjeta se está procesando. La suscripción se actualizará en cuanto el banco lo confirme.`,
        automaticPixAuthorized: `Pix Automático autorizado.`,
        automaticPixFailed: `No pudimos crear la autorización. Inténtalo de nuevo.`,
        automaticPixRejected: `Tu banco no autorizó el Pix Automático. Inténtalo de nuevo o usa tarjeta.`,
      },
    },
    historyPage: {
      title: `Historial de pagos`,
      subtitle: `{{productName}} · {{price}}`,
      chargeStatus: {
        paid: `Aprobado`,
        refused: `Rechazado`,
        retrying: `En reintento`,
        waitingPayment: `Esperando pago`,
        scheduled: `Programado`,
        refunded: `Reembolsado`,
        chargedback: `Chargeback`,
        canceled: `Cancelado`,
        processing: `Procesando`,
        authorized: `Autorizado`,
        refundRequested: `Reembolso solicitado`,
        inSettlement: `Reembolso en proceso`,
        acquirerError: `Reembolso no concluido`,
        blocked: `Bloqueado`,
        inProtest: `En disputa`,
        partiallyPaid: `Pagado parcialmente`,
        prechargeback: `Disputa en revisión`,
        med: `En análisis (MED)`,
      },
      detail: {
        firstCharge: `1er cobro`,
        coupon: `cupón {{code}}`,
        retry: `reintento {{attempt}}`,
        settledAt: `liquidado el {{paidAt}}`,
      },
      footnote: `Cada intento queda registrado con el motivo del rechazo cuando está disponible — no se omite nada.`,
      empty: `Todavía no hay cobros registrados en esta suscripción.`,
    },
    successPage: {
      titleCard: `Impago resuelto`,
      titleAutomaticPix: `Pix Automático autorizado`,
      titlePix: `Pago confirmado`,
      bodyCard: `El sistema ejecutó un nuevo cobro de {{productName}} en la nueva tarjeta y fue aprobado. Tu acceso está garantizado y el próximo cobro será el {{nextChargeAt}}.`,
      bodyAutomaticPix: `Recibimos la autorización de tu banco. El sistema está ejecutando el nuevo cobro de {{productName}} — no necesitas hacer nada más.`,
      bodyPix: `Recibimos el Pix de {{productName}}. Tu acceso está garantizado y el próximo cobro será el {{nextChargeAt}}.`,
      statusLabel: `Estado de la suscripción:`,
      back: `Volver a mis suscripciones`,
      footnote: `El impago quedó resuelto: se detuvo la secuencia de reintentos, se recalculó el próximo cobro, se envió la confirmación por correo y WhatsApp y se disparó el webhook.`,
    },
  },
  refundFlow: {
    common: {
      logoAlt: `Logo Cakto`,
      back: `Volver`,
      of: `de`,
    },
    headerPurchase: {
      loggedInAs: `Has iniciado sesión como`,
      signOut: `Cerrar sesión`,
    },
    purchasesPage: {
      title: `Mis compras`,
    },
    home: {
      title: `Solicitar reembolso`,
      descriptionLine1: `Puedes solicitar un reembolso hasta 7 días después de la compra.`,
      descriptionLine2: `Al solicitar un reembolso, tu compra será cancelada y ya no tendrás acceso al producto.`,
      identifierLabel: `Correo o teléfono usado en la compra`,
      identifierPlaceholder: `Ingresa tu correo o teléfono (con código de área)`,
      findPurchase: `Encontrar tu compra`,
      google: {
        signIn: `Entrar con Google`,
        or: `o`,
        signingIn: `Entrando con Google…`,
        notice: {
          noAccount: `No encontramos una cuenta o compra con el correo de Google. Ingresa el correo o el teléfono usado en la compra.`,
          useCode: `Para este correo, confirma con el código: escribe el correo abajo.`,
          expired: `Tu acceso con Google expiró. Inténtalo de nuevo.`,
          failed: `No fue posible entrar con Google. Inténtalo de nuevo.`,
        },
      },
      validation: {
        identifierRequired: `Ingresa el correo o el teléfono usado en la compra`,
        identifierInvalid: `Ingresa un correo válido o un teléfono con código de área`,
      },
      errors: {
        sendCode: `Ocurrió un error al enviar el código. Inténtalo de nuevo más tarde.`,
      },
    },
    verifyEmail: {
      exit: `Salir`,
      title: `Verifica tu correo`,
      titleWhatsapp: `Verifica tu WhatsApp`,
      description: `Si el correo {{email}} está vinculado a una compra, recibirás un código de verificación. Ingrésalo abajo para continuar.`,
      descriptionWhatsapp: `Si el número {{phone}} está vinculado a una compra, recibirás un código de verificación por WhatsApp. Ingrésalo abajo para continuar.`,
      resendCode: `Reenviar código`,
      continue: `Confirmar código`,
      errors: {
        invalidOrExpiredToken: `Token inválido o caducado. Vuelve a iniciar el proceso de verificación.`,
      },
    },
    purchase: {
      pageHeading: `Solicitar un reembolso`,
      pageSubtitle: `Revisa los datos de la compra y elige el motivo. Los campos obligatorios deben completarse para continuar.`,
      loadingDetails: `Cargando detalles de la compra…`,
      loadError: `No pudimos cargar esta compra. Verifica tu conexión e inténtalo de nuevo.`,
      retry: `Reintentar`,
      orderNotFound: `No encontramos esta compra en tu lista o no tienes permiso para verla.`,
      orderNotFoundCta: `Ver mis compras`,
      backNavAria: `Volver a la lista de compras`,
      backToRefundRequest: `Solicitar reembolso`,
      productDetailsTitle: `Detalles del producto`,
      refundReasonTitle: `Motivo del reembolso`,
      selectReasonRequired: `Selecciona el motivo del reembolso (obligatorio)*`,
      otherReason: `Otro motivo`,
      explainLabel: `Explícalo con tus palabras`,
      explainPlaceholder: `Cuéntale al vendedor con más detalle por qué estás pidiendo un reembolso`,
      requestRefundButton: `Solicitar reembolso`,
      installments: `{{installments}}x de {{amount}}`,
      fields: {
        productName: `Nombre del producto`,
        amount: `Valor`,
        purchaseDate: `Fecha de compra`,
        refundDeadline: `Fecha límite para solicitar reembolso`,
        paymentMethod: `Método de pago`,
        supportEmail: `Correo de soporte del vendedor`,
        producerName: `Nombre del vendedor`,
      },
      paymentMethods: {
        pix: `Pix`,
        creditCard: `Tarjeta`,
        ticket: `Boleto`,
        billet: `Boleto`,
        oxxo: `OXXO`,
        spei: `SPEI`,
        pixAuto: `Pix Automático`,
        boleto: `Boleto`,
        debitCard: `Tarjeta de débito`,
        pagaleveInstallments: `Pix en {{installments}} cuotas sin interés`,
        pagaleveUpfront: `Pix al contado`,
        picpay: `PicPay`,
        googlepay: `Google Pay`,
        applepay: `Apple Pay`,
        paypal: `PayPal`,
        nubank: `Nubank`,
        mercadopago: `Mercado Pago`,
        pse: `PSE`,
        nequi: `Nequi`,
        safetypay: `SafetyPay`,
        unknown: `Desconocido`,
      },
      refundReasons: {
        optionAccessIssue: `Todavía no pude acceder al producto, pero me gustaría acceder`,
        optionNeedMoney: `Necesito el dinero para otras cosas`,
        optionFilesNotOpening: `Recibí acceso, pero las páginas o archivos no se abren`,
        optionNoSupportResponse: `El vendedor no responde a mis solicitudes de soporte`,
        optionLowQuality: `La calidad del producto no cumplió mis expectativas`,
        optionIncompleteProduct: `El producto está incompleto`,
        optionDuplicatePurchase: `Compra duplicada`,
      },
      bankInfo: {
        title: `Datos bancarios para el reembolso`,
        descriptionRequired: `Este pago se hizo en efectivo, así que necesitamos la cuenta donde quieres recibir tu dinero de vuelta. Sin estos datos no podemos completar el reembolso.`,
        descriptionOptional: `Si quieres recibir el reembolso en una cuenta específica, ingresa los datos abajo. También puedes dejarlos en blanco.`,
        fields: {
          clabe: `CLABE`,
          clabeHelper: `Los 18 dígitos de tu cuenta CLABE`,
          bank_account_holder_name: `Nombre del titular de la cuenta`,
          bank_account_holder_document: `Documento del titular (CURP o RFC)`,
          bank_name: `Banco`,
          bank_branch: `Sucursal`,
          bank_account: `Cuenta`,
          account_type: `Tipo de cuenta`,
        },
        validation: {
          clabe: `CLABE inválida. Revisa los 18 dígitos.`,
          maxLength: `El valor supera el largo permitido`,
        },
      },
      validation: {
        required: `Campo obligatorio`,
      },
      errors: {
        requestRefund: `Hubo un error al intentar realizar el reembolso. Contacta directamente al vendedor.`,
      },
    },
    successModal: {
      title: `Reembolso confirmado`,
      description: `Recibimos tu solicitud y ya está en proceso.`,
      deadlineTitle: `Recibirás tu reembolso en hasta 24 horas`,
      deadlineDescription: `El importe vuelve automáticamente, sin necesidad de aprobación del vendedor.`,
      deadlineDescriptionWithAmount: `Los {{amount}} vuelven automáticamente, sin necesidad de aprobación del vendedor.`,
      stepEmail: `Enviamos la confirmación a tu correo.`,
      stepMethod: `La devolución es total y al mismo medio de pago de la compra.`,
      trackRefund: `Seguir mi reembolso`,
      backHome: `Volver a la página inicial`,
    },
    confirmCancelRefund: {
      title: `Tu reembolso está en proceso`,
      greeting: `Hola, {{userFirstName}}. ¿Todo bien?`,
      processingMessage: `Recibimos tu solicitud de reembolso del producto {{productName}} y ya la estamos procesando. El valor de {{currentPrice}} será devuelto en hasta 24 horas hábiles.`,
      changedMindTitle: `¿Cambiaste de idea?`,
      changedMindDescription: `Si quieres mantener el producto, puedes cancelar el reembolso aquí:`,
      keepPurchase: `Mantener mi compra`,
      orderDetailsTitle: `Detalles del pedido`,
      orderIdLabel: `ID:`,
      orderAmountLabel: `Valor:`,
      supportMessage: `Si tienes dudas sobre el producto, contacta con el soporte del productor mediante el correo abajo:`,
      orCountOn: `o cuenta con el`,
      caktoSupport: `soporte de Cakto`,
      snackbar: {
        success: `Reembolso cancelado con éxito`,
        error: `Error al cancelar el reembolso`,
      },
    },
    howRefundsWork: {
      title: `¿Cómo funciona el reembolso?`,
      description: `Nuestra política garantiza 7 días corridos para solicitar reembolso en cualquier compra. Enviada la solicitud, tu reembolso se procesa automáticamente en hasta 24 horas: el vendedor recibe el aviso y tiene ese plazo para hablar contigo, pero la devolución no depende de su aprobación. El valor se devuelve completo al mismo método de pago de la compra.`,
    },
    modalTrySupport: {
      title: `¿Necesitas ayuda con tu compra?`,
      descriptionLine1: `Muchos problemas pueden resolverse rápidamente con el productor.`,
      descriptionLine2: `Si lo prefieres, habla con soporte antes de seguir con el reembolso:`,
      talkToSupport: `Hablar con soporte`,
      continueRefund: `Continuar con el reembolso`,
    },
    modalRefundBlocked: {
      title: `Este reembolso lo gestiona el productor`,
      descriptionLine1: `El productor es el responsable del reembolso de este producto.`,
      descriptionLine2: `Ponte en contacto con él a través del correo de abajo para solicitar tu reembolso.`,
      talkToSupport: `Hablar con el productor`,
    },
    modalRefundInsufficientBalance: {
      title: `No es posible solicitar el reembolso ahora`,
      description: `No hay saldo disponible para devolver el importe de esta compra, por eso tu solicitud de reembolso no se abrió.`,
      productSupport: `Ponte en contacto con el soporte del producto a través del correo de abajo:`,
      caktoSupportFallback: `Si no se resuelve, habla con el soporte de Cakto.`,
      caktoSupportOnly: `Habla con el soporte de Cakto para saber cómo seguir.`,
      talkToProductSupport: `Hablar con el soporte del producto`,
      talkToCaktoSupport: `Hablar con el soporte de Cakto`,
      close: `Cerrar`,
    },
    purchaseCard: {
      productImageAlt: `Producto`,
      fields: {
        amount: `Valor:`,
        purchaseDate: `Fecha de compra:`,
        refundDeadline: `Fecha límite para solicitar reembolso:`,
        refundDeadlineShort: `Reembolso hasta:`,
        status: `Estado:`,
        unknown: `Desconocido`,
      },
      status: {
        processing: `Procesando`,
        authorized: `Autorizado`,
        paid: `Pagado`,
        refunded: `Reembolsado`,
        waiting_payment: `En espera de pago`,
        refused: `Rechazado`,
        chargedback: `Contracargo`,
        canceled: `Cancelado`,
        in_protest: `En disputa`,
        partially_paid: `Parcialmente pagado`,
        refund_requested: `Reembolso en proceso`,
        acquirer_error: `Reembolso no concluido`,
        in_settlement: `Reembolso en proceso`,
        expired: `Expirado`,
      },
      refundFailed: {
        title: `No fue posible concluir tu reembolso`,
        description: `El vendedor, o uno de sus afiliados, no tiene saldo disponible para devolver el importe. Contáctalo directamente por el correo de abajo:`,
      },
      refundInProgress: {
        title: `Reembolso en proceso`,
        description: `El importe se devolverá en hasta 24 horas, al mismo medio de pago de la compra.`,
      },
      refundSent: {
        title: `Reembolso enviado al medio de pago`,
        description: `Este reembolso ya no se puede cancelar. Estamos esperando la confirmación del medio de pago, y el plazo para ver el importe depende de tu banco o del emisor de la tarjeta.`,
      },
      refundInReview: {
        title: `Tu reembolso está en revisión`,
        description: `El medio de pago no confirmó la devolución y nuestro equipo lo está verificando. No necesitas solicitarlo de nuevo. Si quieres hablar con el vendedor, usa el correo de abajo:`,
      },
      requestRefund: `Solicitar reembolso`,
      expiredRefund: `Reembolso expirado`,
      refundBlocked: `Reembolso bloqueado`,
      cancelRefund: `Cancelar reembolso`,
      snackbar: {
        notFound: `No se encontró ninguna solicitud de reembolso`,
        expiredUpdating: `La solicitud de reembolso expiró, estamos actualizando la información`,
      },
    },
    renderPurchaseCards: {
      empty: `¡No se encontraron compras!`,
    },
  },
  contactPage: {
    pageTitle: {
      area: `Páginas`,
      screen: `Contacto`,
    },
    hero: {
      title: {
        where: `Dónde`,
        to: `encontrarnos`,
        find: `puedes`,
        us: `?`,
      },
    },
    form: {
      titleLine1: `No dudes en contactarnos.`,
      titleLine2: `Estaremos encantados de escucharte.`,
      name: `Nombre`,
      email: `Correo`,
      subject: `Asunto`,
      message: `Escribe tu mensaje aquí.`,
      submit: `Enviar ahora`,
    },
    map: {
      address: `Dirección`,
    },
  },
};

export default es;
